import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchCompensationSentences, fetchedCompensationSentences } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchCompensationSentences>;

export function* getCompensationSentencesSaga({ meta: { callback } }: FetchActionPayload) {
  const { getCompensationSentences } = getAPI();
  const response: YieldOf<typeof getCompensationSentences> = yield call(getCompensationSentences);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedCompensationSentences(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedCompensationSentences(undefined, error));
  }

  if (callback) callback();
}

export default function* compensationSentencesSaga() {
  yield takeLatest(fetchCompensationSentences.type, getCompensationSentencesSaga);
}
